import React from "react";
import { Header, Message, Segment } from "semantic-ui-react";

const Main = () => {
  return (
    <>
      <Header as="h1">Documentation Home</Header>
      <Message info>
        <Message.Header>Welcome to the Documentation</Message.Header>
        <p>
          This documentation provides an overview of the API endpoints, data
          models, and other components of our system. Use the menu on the left
          to navigate through different sections.
        </p>
        <Segment>
          <Header as="h3">Getting Started</Header>
          <p>
            To begin, you can explore the API documentation or check out the
            data models to understand how to interact with our system.
          </p>
        </Segment>
        <Segment>
          <Header as="h3">Under construction</Header>
          <p>
            This documentation is still under construction. We are continuously
            updating it to provide more detailed information and examples.
          </p>
        </Segment>
      </Message>
    </>
  );
};

export default Main;
